import { BaseContainerModel } from '../../base-container.model';
import { bl_dgmkt_campaign_hdr_RowClass } from '../../../dbschema/bl_dgmkt_campaign_hdr.model';
import { bl_dgmkt_campaign_ext_RowClass } from '../../../dbschema/bl_dgmkt_campaign_ext.model';
import { bl_dgmkt_campaign_line_RowClass } from '../../../dbschema/bl_dgmkt_campaign_line.model';
import { bl_dgmkt_campaign_event_RowClass } from '../../../dbschema/bl_dgmkt_campaign_event.model';

export class DgMktCampaignContainerModel extends BaseContainerModel {
  bl_dgmkt_campaign_hdr: bl_dgmkt_campaign_hdr_RowClass = new bl_dgmkt_campaign_hdr_RowClass();
  bl_dgmkt_campaign_exts: bl_dgmkt_campaign_ext_RowClass[] = [];
  bl_dgmkt_campaign_lines: bl_dgmkt_campaign_line_RowClass[] = [];
  bl_dgmkt_campaign_events: bl_dgmkt_campaign_event_RowClass[] = [];
}
